import {text_mod_28, } from "../text/Text.js";
export const module28 = {
  title:
    "§28. Створюю розповідь про домашнього улюбленця або іншу тварину",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_28, },
    ]
  }
